import { useElementWidth } from "./useElementWidth";

export const useIsMobileForTripLayout = () => {
  const [ref, width] = useElementWidth();
  const isMobile = width < 720;
  return { ref, isMobile };
};
